import {useTranslation} from "react-i18next";
import dayjs from "dayjs";

export const InnerCardWrapper = ({ header, value }) => {
    return (
        <div className='apartment-info-inner-wrapper'>
            <div className='header'>{header}</div>
            <div className='value'>{value}</div>
        </div>
    )
};

const getNextActionIn = (nextActionDateStr, t) => {
    const nextActionDate = dayjs(nextActionDateStr);
    const hours = nextActionDate.diff(Date.now(), 'hour');

    const mustBeDays = hours >= 24;
    const nextActionInText = mustBeDays ? t('monitoring.activeMonitoring.labels.days') : t('monitoring.activeMonitoring.labels.hours');
    let nextActionIn;

    if (mustBeDays) {
        nextActionIn = Math.ceil(hours / 24);
    } else {
        if (hours === 0) {
            nextActionIn = '< 1';
        } else {
            nextActionIn = hours;
        }
    }

    return {nextActionIn, nextActionInText};
}



const MonitoringInfo = ({ monitoringData, type }) => {
    const { nextActionDate, nextActionName, lastActionName, lastActionDate } = monitoringData;
    const { t } = useTranslation();

    const { nextActionIn, nextActionInText } = getNextActionIn(nextActionDate, t);
    const sentAt = dayjs(lastActionDate).format('DD/MM/YYYY hh:mm');

  return (
      <div className='next-row'>
        <InnerCardWrapper
            header={t('monitoring.activeMonitoring.labels.tenantValue')}
            value={t(`monitoring.activeMonitoring.labels.${type}`)}
        />
        <InnerCardWrapper
            header={t('monitoring.activeMonitoring.labels.actionName')}
            value={t(`monitoring.activeMonitoring.actions.${lastActionName}`)}
        />
        <InnerCardWrapper
            header={t('monitoring.activeMonitoring.labels.nextActionIn')}
            value={`${nextActionIn} ${nextActionInText}`}
        />
        <InnerCardWrapper
            header={t('monitoring.activeMonitoring.labels.nextActionName')}
            value={t(`monitoring.activeMonitoring.actions.${nextActionName}`)}
        />
          <InnerCardWrapper
              header={t('monitoring.activeMonitoring.labels.sentAt')}
              value={sentAt}
          />
    </div>
  )
};

export default MonitoringInfo;
